<!-- Campana de avisos. Sin fraccionamiento no se pinta: no hay a quién
     preguntarle avisos y el header del dashboard no debe disparar peticiones. -->
@if (neighborhoodId) {

  <div
    ngbDropdown
    #bellDropdown="ngbDropdown"
    placement="bottom-end"
    container="body"
    class="d-inline-block notificationsBell">

    <button
      type="button"
      class="btn notificationsBell__button"
      id="notificationsBellToggle"
      ngbDropdownToggle
      [attr.aria-label]="buttonLabel">

      <i class="material-icons notificationsBell__icon" aria-hidden="true">notifications</i>

      <!-- El badge está posicionado en absoluto: aparecer o desaparecer nunca
           mueve nada de lo que tiene al lado. El número ya lo dice el
           aria-label del botón, así que aquí sobra para el lector. -->
      @if (!notificationService.loading && unseenCount > 0) {
        <span class="notificationsBell__badge" aria-hidden="true">{{ badgeLabel }}</span>
      }

    </button>

    <span class="visually-hidden" role="status" aria-live="polite">{{ buttonLabel }}</span>

    <div
      ngbDropdownMenu
      aria-labelledby="notificationsBellToggle"
      class="notificationsBell__menu">

      <div class="notificationsBell__header">
        <span class="notificationsBell__title">Avisos</span>

        @if (!notificationService.loading && !notificationService.loadFailed) {
          <span class="notificationsBell__headerCount">{{ unseenLabel }}</span>
        }
      </div>

      <!-- ---------------------------------------------------------------- -->
      <!--                        ANCHOR CARGANDO                           -->
      <!-- ---------------------------------------------------------------- -->
      @if (notificationService.loading) {

        <div class="notificationsBell__skeleton placeholder-glow" aria-hidden="true">
          @for (row of [1, 2, 3]; track row) {
            <div class="notificationsBell__skeletonItem">
              <span class="placeholder notificationsBell__skeletonIcon rounded-circle"></span>
              <span class="notificationsBell__skeletonText">
                <span class="placeholder col-7 rounded"></span>
                <span class="placeholder col-10 rounded"></span>
                <span class="placeholder col-4 rounded"></span>
              </span>
            </div>
          }
        </div>

      <!-- ---------------------------------------------------------------- -->
      <!--                          ANCHOR ERROR                            -->
      <!-- ---------------------------------------------------------------- -->
      } @else if (notificationService.loadFailed) {

        <div class="notificationsBell__state">
          <i class="material-icons notificationsBell__stateIcon" aria-hidden="true">cloud_off</i>
          <p class="notificationsBell__stateText mb-2">No se pudieron cargar los avisos.</p>
          <button
            type="button"
            class="btn notificationsBell__retryButton"
            (click)="retry()">
            Reintentar
          </button>
        </div>

      <!-- ---------------------------------------------------------------- -->
      <!--                          ANCHOR VACÍO                            -->
      <!-- ---------------------------------------------------------------- -->
      } @else if (notificationService.notifications.length === 0) {

        <div class="notificationsBell__state">
          <i class="material-icons notificationsBell__stateIcon" aria-hidden="true">notifications_none</i>
          <p class="notificationsBell__stateText mb-0">No tienes avisos en este fraccionamiento.</p>
        </div>

      <!-- ---------------------------------------------------------------- -->
      <!--                          ANCHOR LISTA                            -->
      <!-- ---------------------------------------------------------------- -->
      } @else {

        <div class="notificationsBell__list">

          @for (notification of notificationService.notifications; track notification.notificationId) {

            <button
              type="button"
              class="notificationsBell__item"
              [class.notificationsBell__itemUnseen]="!notification.seen"
              (click)="open(notification)">

              <span class="notificationsBell__itemIcon">
                <i class="material-icons" aria-hidden="true">{{ icon(notification) }}</i>
              </span>

              <span class="notificationsBell__itemBody">

                <span class="notificationsBell__itemTop">
                  <span class="notificationsBell__itemTitle">{{ notification.title }}</span>

                  <!-- Sin ver no se dice solo con un punto de color. -->
                  @if (!notification.seen) {
                    <span class="notificationsBell__tag">Sin ver</span>
                  }
                </span>

                <span class="notificationsBell__itemSubtitle">{{ notification.subtitle }}</span>

                <time
                  class="notificationsBell__itemDate"
                  [attr.datetime]="dateTime(notification)"
                  [title]="dateLabel(notification)">
                  {{ relativeDateLabel(notification) }}
                </time>

              </span>

              @if (notification.isReport) {
                <i class="material-icons notificationsBell__itemChevron" aria-hidden="true">chevron_right</i>
              }

            </button>

          }

        </div>

      }

    </div>

  </div>

}
